/**
 *  Place all URL params here. Use snake-case as the convention with "PARAM" as the suffix
 */

export const SERVER_ID_PARAM = 'serverId';

export const ADDRESS_ID_PARAM = 'addressId';

export const LOCATION_ID_PARAM = 'locationId';

export const PRODUCT_ID_PARAM = 'productId';

export const IS_MRO = 'isMro';

export const TERM_ID_PARAM = 'termId';

export const PARAM_REMOVECARTKEY = 'cartUpdated';

export const URL_PARAM_MOBILE_DISCOUNT = 'discount';

export const URL_PARAM_POWER_DISCOUNT = 'powerDiscount';

export const URL_PARAM_PRICE_GST = 'price';
